<div id="selection-popup">
  <h2 class="m-b-5" mat-dialog-title>Traspasar</h2>
  <div mat-dialog-content id="leave-popup-fields">
    <div *ngIf="sharedService.selectedSelectionTabId == 1" >
      <mat-label>Empresa Destino</mat-label>
      <app-tree-view (companyNode)="companyNode=$event" [origin]="1"></app-tree-view>
      <!-- ORIGIN IS 1 FOR TREE VIEWS THAT ARE NOT IN THE HEADER -->
    </div>
    <div class="text-a-r p-t-5">
      <button mat-raised-button color="accent" (click)="Accept()" class="m-r-15">Consultar</button>
      <button mat-raised-button (click)="Close()" color="warn">Cancelar</button>
    </div>
  </div>
</div>